// extracted by css-extract-rspack-plugin
export default {"btn-add":"chmgqM","btnAdd":"chmgqM"};